import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth-store";
import { canOpenPreviewPath } from "@/lib/preview-gating";

/**
 * Route guard for a built-but-unlaunched page (see `lib/preview-gating.ts`).
 * Anyone outside the page's preview audience is bounced the way
 * `RequireRole` bounces them, so a typed or bookmarked URL cannot reach it.
 */
export function RequirePreview({ children, path }: { children: ReactNode; path: string }) {
  const role = useAuthStore((s) => s.user?.role ?? "");
  if (!canOpenPreviewPath(role, path)) {
    if (role === "DRIVER") return <Navigate to="/drive" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
